import { useFormPersistenceContext } from '@/contexts/form-persistence'
import { useTranslation } from 'react-i18next'
import {
    Text,
    Button,
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogBody,
    DialogFooter,
} from '@vnetwork/datacentral-ui/primitives'

const FormPersistenceRestoreDialog = () => {
    const { t } = useTranslation()
    const { shouldRestore, acceptRestore, declineRestore } =
        useFormPersistenceContext()

    if (!shouldRestore) return null

    return (
        <Dialog open onOpenChange={(open) => !open && declineRestore()}>
            <DialogContent size="md" closeOnOutsideClick={false}>
                <DialogHeader>
                    <DialogTitle>{t('restore-form-persistence')}</DialogTitle>
                </DialogHeader>
                <DialogBody>
                    <Text as="div" size="lg">
                        {t('restore-form-persistence-confirmed')}
                    </Text>
                </DialogBody>
                <DialogFooter>
                    <Button
                        variant="secondary"
                        onClick={declineRestore}
                        className="min-w-[100px]"
                    >
                        {t('no')}
                    </Button>
                    <Button onClick={acceptRestore} className="min-w-[150px]">
                        {t('yes')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default FormPersistenceRestoreDialog
